<div
    data-testid="global-table-row-item"
    class="grid gap-2 bg-shui-base-2 hover:bg-shui-base-4 cursor-pointer my-2 py-3 pr-4 pl-8 items-center rounded-md relative h-11"
    [style.grid-template-columns]="gridTemplateColumns()"
>
    <span class="absolute top-2 left-4 bottom-2 w-1 rounded-full" [style.background-color]="pillColor()"></span>
    <ng-content selector="app-table-cell"></ng-content>
</div>
